"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.WpsHelper = void 0;
var hepler_abstract_1 = require("./hepler-abstract");
var index_1 = __importDefault(require("../base/index"));
var WpsHelper = /** @class */ (function (_super) {
    __extends(WpsHelper, _super);
    function WpsHelper() {
        return _super.call(this) || this;
    }
    WpsHelper.prototype.getDeviceId = function () {
        var _a, _b, _c;
        if (!this.device_id) {
            var hdid = ((_c = (_b = (_a = window.Extention) === null || _a === void 0 ? void 0 : _a.Base) === null || _b === void 0 ? void 0 : _b.WpsOffice.getAppInfo()) === null || _c === void 0 ? void 0 : _c.result).hdid;
            this.device_id = hdid;
        }
        return this.device_id;
    };
    WpsHelper.prototype.getClientType = function () {
        switch (index_1.default.getClientType()) {
            case 'wpsmac':
                return 'wps-mac';
            case 'wpspc':
            default:
                return 'wps-pc';
        }
    };
    WpsHelper.prototype.getAiServerHeaders = function () {
        var _a, _b, _c, _d, _e;
        var _f = (_c = (_b = (_a = window.Extention) === null || _a === void 0 ? void 0 : _a.Base) === null || _b === void 0 ? void 0 : _b.WpsOffice.getAppInfo()) === null || _c === void 0 ? void 0 : _c.result, appname = _f.appname, version = _f.version, hdid = _f.hdid, channel = _f.channel;
        this.device_id = hdid;
        var language = ((_e = (_d = window.Extention) === null || _d === void 0 ? void 0 : _d.Base.Product.language()) === null || _e === void 0 ? void 0 : _e.result).language;
        return {
            'x-client-type': this.getClientType(),
            'x-component': appname,
            'x-client-ver': version,
            'x-client-chan': channel,
            'x-device-id': hdid,
            'x-client-lang': language,
            'x-product': 'WPS',
            'content-type': 'application/json',
            'x-client-request-id': this.genClientRequestId(),
        };
    };
    WpsHelper.prototype.getAiServerHeadersV5 = function () {
        var _a, _b, _c, _d, _e;
        var _f = (_c = (_b = (_a = window.Extention) === null || _a === void 0 ? void 0 : _a.Base) === null || _b === void 0 ? void 0 : _b.WpsOffice.getAppInfo()) === null || _c === void 0 ? void 0 : _c.result, appname = _f.appname, version = _f.version, hdid = _f.hdid, hdid3 = _f.hdid3, channel = _f.channel;
        this.device_id = hdid;
        var language = ((_e = (_d = window.Extention) === null || _d === void 0 ? void 0 : _d.Base.Product.language()) === null || _e === void 0 ? void 0 : _e.result).language;
        return {
            'x-client-request-id': this.genClientRequestId(),
            'x-client-product': 'WPS',
            'x-client-type': this.getClientType(),
            'x-client-version': version,
            'x-client-Channel': channel,
            'x-client-language': language,
            'x-client-component': appname,
            'x-client-device-id': hdid,
            'x-client-hdid1': hdid,
            'x-client-hdid3': hdid3 || '',
        };
    };
    return WpsHelper;
}(hepler_abstract_1.HelperAbtract));
exports.WpsHelper = WpsHelper;
exports.default = new WpsHelper();
